// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1eSFD","rootNoMargin":"styles_rootNoMargin__Xv5he"};